import { Action } from "redux"

import * as actions from "./actions"

export const initialState: Shortcuts.Shortcuts = {
    shortcuts: {},
    isLoading: false,
    filter: "",
    initialized: false,
    workspaceId: 0,
}

const ACTION_HANDLERS: {
    [action: string]: (
        state: Shortcuts.Shortcuts,
        props: Action,
    ) => Shortcuts.Shortcuts
} = {
    [actions.SET_INITIALIZED]: (state): Shortcuts.Shortcuts => ({
        ...state,
        initialized: true,
    }),

    [actions.REQUEST_SHORTCUTS]: (state): Shortcuts.Shortcuts => ({
        ...state,
        isLoading: true,
    }),

    [actions.RECEIVE_SHORTCUTS]: (
        state,
        { shortcuts: shortcutsArray }: actions.ReceiveShortcuts,
    ): Shortcuts.Shortcuts => {
        const shortcuts: Record<string, Models.Shortcut> = {}
        shortcutsArray.forEach((shortcut) => {
            if (!!shortcut.id) {
                shortcuts[shortcut.id.toString()] = shortcut
            }
        })

        return {
            ...state,
            shortcuts: shortcuts,
            isLoading: false,
        }
    },

    [actions.FILTER_SHORTCUTS]: (
        state,
        { filter }: actions.FilterShortcuts,
    ): Shortcuts.Shortcuts => ({ ...state, filter }),
}

export default function reducer(
    state: Shortcuts.Shortcuts = initialState,
    action: Action,
): Shortcuts.Shortcuts {
    const handler: (
        state: Shortcuts.Shortcuts,
        action: Action,
    ) => Shortcuts.Shortcuts = ACTION_HANDLERS[action.type]
    return handler ? handler(state, action) : state
}
